import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, Pencil, Power, Trash2 } from "lucide-react";

export const SortableCategoryCard = ({ category, onDelete, onEdit, onToggle }) => {
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: category.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <article
      ref={setNodeRef}
      style={style}
      className={[
        "overflow-hidden border border-[#E2DCD2] bg-white rounded-xl",
        isDragging ? "z-20 opacity-70 shadow-lg" : "",
      ].join(" ")}
      data-testid={`admin-category-card-${category.id}`}
    >
      <div className="relative">
        <img
          src={category.image}
          alt={category.name}
          className="aspect-square w-full object-cover"
        />
        <button
          type="button"
          {...attributes}
          {...listeners}
          className="absolute left-2 top-2 cursor-grab rounded bg-white/95 p-2 text-[#2D5A47] shadow-sm active:cursor-grabbing"
          style={{ touchAction: "none" }}
          aria-label={`Hold and move ${category.name}`}
          title="Hold and drag to reorder"
          data-testid={`category-drag-handle-${category.id}`}
        >
          <GripVertical size={18} />
        </button>
      </div>
      <div className="flex items-center justify-between gap-2 p-3">
        <span className="text-sm font-semibold">{category.name}</span>
        <div className="flex items-center">
          <button
            type="button"
            onClick={() => onEdit(category)}
            className="p-1.5 text-[#2D5A47]"
            data-testid={`edit-category-${category.id}`}
            aria-label={`Edit ${category.name}`}
          >
            <Pencil size={14} />
          </button>
          <button
            type="button"
            onClick={() => onToggle(category)}
            className={`rounded p-1.5 text-white ${
              category.active ? "bg-emerald-600" : "bg-[#7F1D1D]"
            }`}
            data-testid={`toggle-category-${category.id}`}
            aria-label={category.active ? `Disable ${category.name}` : `Enable ${category.name}`}
          >
            <Power size={14} />
          </button>
          <button
            type="button"
            onClick={() => onDelete(category.id)}
            className="p-1.5 text-red-500"
            data-testid={`delete-category-${category.id}`}
            aria-label={`Delete ${category.name}`}
          >
            <Trash2 size={14} />
          </button>
        </div>
      </div>
    </article>
  );
};